import { Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

// "#3c6e71" "#05668d"
// "#9E0059" "#427aa1"
// "#390099" "#0fa3b1"
// "#FF5400" "#21295c"
// "#FF0054" "#679436"
// "#FFBD00" "#a5be00"

const mapping = {
  [-1]: {
    label: "-",
    backgroundColor: "#f1f1f1",
    color: "grey",
  },
  0: {
    label: "Weak match",
    backgroundColor: "#ffdddd",
    color: "#bb1717",
  },
  1: {
    label: "Moderate match",
    backgroundColor: "#fff0c2", //"#FFFAEB",
    color: "#a2702a", //"#b57314",
  },
  2: {
    label: "Good match",
    backgroundColor: "#d7efd7",
    color: "#47981e",
  },
  // 3: {
  //   label: "Excellent match",
  //   backgroundColor: "#84ecaa",
  //   color: "#1d4b05",
  // },
};

const getBackgroundColor = (props) => {
  return mapping[props.score]["backgroundColor"];
};

const getTextColor = (props) => {
  return mapping[props.score]["color"];
};

const getLabel = (state) => {
  return mapping[state]["label"];
};

const useStyles = makeStyles((theme) => ({
  stateBadge: {
    backgroundColor: getBackgroundColor,
    margin: "4px",
    fontSize: "12px",
    color: getTextColor,
    "& .MuiChip-deleteIcon": {
      color: "#2a313536",
    },
  },
}));

export default function ScreenoScoreBadge(props) {
  const classes = useStyles(props);
  return (
    <Chip
      size="small"
      label={<b>{getLabel(props.score)}</b>}
      className={classes.stateBadge}
      onDelete={props.onDelete}
    />
  );
}
